import request from "./request";
import {
  baseUrl,
  getPayChannel,
  setPayChannel
} from "@/utils/auth";

/**
 * 微信相关接口
 * @author 小圣贤君
 * @time 2020/03/13
 */
export default {
  /**
   * 微信网页授权
   */
  wxAuth(redirectUri) {
    let payChannel = "";
    let payChannelVersion = "2";
    let host = window.location.host; // 获取URL的主机部分
    if (host == "sdb.giga99.com") {
      // if(payChannelVersion === "1"){
      //   payChannel = "1007";
      // }else if(payChannelVersion === "2"){
      //   payChannel = "1017";
      // }

      if(payChannelVersion === "1"){
        payChannel = "1016";
      }else if(payChannelVersion === "2"){
        payChannel = "1016";
      }

    }
    else if (host == "sdb.ganzhoubx.com") {
      if(payChannelVersion === "1"){
        payChannel = "1008";
      }else if(payChannelVersion === "2"){
        payChannel = "1012";
      }
    }
    else if (host == "sdb.gzjiajiuhui.com") {
      if(payChannelVersion === "1"){
        payChannel = "1005";
      }else if(payChannelVersion === "2"){
        payChannel = "1018";
      }
    }
    else if (host == "sdb.fuqiyymx.com") {
      if(payChannelVersion === "1"){
        payChannel = "1009";
      }else if(payChannelVersion === "2"){
        payChannel = "1016";
      }
    }
    else if (host == "sdb.beifuyymx.com") {
      if(payChannelVersion === "1"){
        payChannel = "1010";
      }else if(payChannelVersion === "2"){
        payChannel = "1013";
      }
    }
    else if (host == "sdb.cehaoyymx.com") {
      if(payChannelVersion === "1"){
        payChannel = "1011";
      }else if(payChannelVersion === "2"){
        payChannel = "1015";
      }
    }
    else if (host == "sdb.ganzhoublq.com") {
      if(payChannelVersion === "1"){
        payChannel = "1004";
      }else if(payChannelVersion === "2"){
        payChannel = "1014";
      }
    }
    else {
      payChannel = "1012";
    }
    payChannel = "1019";
    setPayChannel(payChannel);
    window.location.href = baseUrl() + "/api/user/wx/view/getWeChatCode?redirect_uri=" + encodeURIComponent(redirectUri)+"&payChannel="+payChannel;
  },
  /**
   * 获取微信配置
   * @param url 页面url href.split('#')[0]
   */
  getConfig(url) {
    return request.post('/user/wechat/getWxConfig?url=' + encodeURIComponent(url));
  }
}



// WEBPACK FOOTER //
// ./src/api/wxService.js